import React from "react";
import styled from "styled-components";
import PerformanceGrid from "./PerformanceGrid";

interface MidiExportSectionProps {
  disabled?: boolean;
}

const MidiExportSection: React.FC<MidiExportSectionProps> = () => {
  const handleNotImplemented = () => {
    window.alert(
      "We haven't implemented this feature yet. Please check back soon."
    );
  };

  return (
    <MidiExportSectionWrapper id="midi-export-section">
      <MidiExportPanel id="midi-export-panel">
        <MidiExportTitle id="midi-export-title">Export</MidiExportTitle>
        <MidiExportButtons id="midi-export-buttons">
          <MidiExportButton
            id="midi-export-chords-button"
            type="button"
            onClick={handleNotImplemented}
          >
            Audio
          </MidiExportButton>
          <MidiExportSecondaryButton
            id="midi-export-basemodes-button"
            type="button"
            onClick={handleNotImplemented}
          >
            Midi
          </MidiExportSecondaryButton>
        </MidiExportButtons>
      </MidiExportPanel>
      <PerformanceGrid />
    </MidiExportSectionWrapper>
  );
};

export default MidiExportSection;

// Styled Components
const MidiExportSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 160px;
  max-width: 160px;
  flex-shrink: 0;
  align-self: stretch;
  padding-top: 6px;
  justify-content: space-between;
`;

const MidiExportPanel = styled.div`
  width: 100%;
  padding: 18px 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  position: relative;
  border: 2px solid #ccc;
  border-radius: 8px;
  box-sizing: border-box;
  background: transparent;
`;

const MidiExportTitle = styled.h3`
  margin: 0;
  font-size: 13px;
  font-weight: bold;
  color: #333;
  text-align: center;
  letter-spacing: 0.5px;
  position: absolute;
  top: -9px;
  left: 50%;
  transform: translateX(-50%);
  background: #e2e1dd;
  padding: 0 12px;
  border-radius: 4px;
  white-space: nowrap;
`;

const MidiExportButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const MidiExportButton = styled.button`
  padding: 8px 10px;
  background: #111;
  border: 2px solid #111;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  font-family: inherit;
  color: #f5f5f5;
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease;
  text-transform: none;
  letter-spacing: 0.2px;
  width: 100%;

  &:active {
    transform: scale(0.98);
  }

  &:hover {
    opacity: 0.9;
  }
`;

const MidiExportSecondaryButton = styled(MidiExportButton)`
  background: transparent;
  color: #111;
  border-color: #ccc;
`;
